import host from './host'
import { stringify } from './base'

export async function require(method, api, params = null) {
  let data = {}
  data.method = method
  if (method !== 'GET') data.body = JSON.stringify(params)
  else api = params ? api + `?${stringify(params)}` : api

  api = host + api
  const response = await fetch(api, data)
  return await response.json()
}

export function ajax(method, api, params = null) {
  return new Promise((resolve, reject) => {
    let data = new FormData()
    if (method === 'GET' || method === 'DELETE')
      api = params ? api + `?${stringify(params)}` : api
    else
      Object.values(params).map((val, key) =>
        data.append(Object.keys(params)[key], val)
      )
    let url = host + api
    let xhr = new XMLHttpRequest()
    xhr.open(method, url, true)
    xhr.send(data)
    xhr.onload = function() {
      let response = JSON.parse(this.response)
      if (this.status == 200) {
        resolve(response)
      } else {
        reject('加载失败')
      }
    }
    xhr.onerror = function() {
      reject(this)
    }
  })
}
